import { render, staticRenderFns } from "./message_index_btn.vue?vue&type=template&id=650fddca&scoped=true"
import script from "./message_index_btn.vue?vue&type=script&lang=js"
export * from "./message_index_btn.vue?vue&type=script&lang=js"
import style0 from "./message_index_btn.vue?vue&type=style&index=0&id=650fddca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650fddca",
  null
  
)

export default component.exports